import { render, staticRenderFns } from "./serviceCloud.vue?vue&type=template&id=da16aed2&scoped=true"
import script from "./serviceCloud.vue?vue&type=script&lang=js"
export * from "./serviceCloud.vue?vue&type=script&lang=js"
import style0 from "./serviceCloud.vue?vue&type=style&index=0&id=da16aed2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da16aed2",
  null
  
)

export default component.exports